import { render, staticRenderFns } from "./JourneyTile.vue?vue&type=template&id=3fe08b2a&scoped=true&"
import script from "./JourneyTile.vue?vue&type=script&lang=js&"
export * from "./JourneyTile.vue?vue&type=script&lang=js&"
import style0 from "./JourneyTile.vue?vue&type=style&index=0&id=3fe08b2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe08b2a",
  null
  
)

export default component.exports